import React from 'react';

import { Glossary, BoardGL } from 'common/utils/glossary';
import { Column } from 'common/components';

interface UserBoardProps {
  /** UserBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** メールアドレス */
  mailAddress: string;
  /** プロフィールの編集の押下処理 */
  onClickProfile: () => void;
  /** ログアウトの押下処理 */
  onClickLogout: () => void;
}

/**
 * ユーザーメニューのPresentation Component
 */
export const UserBoard: React.FC<UserBoardProps> = ({
  isDisplay,
  glossary,
  mailAddress,
  onClickProfile,
  onClickLogout
}) => {
  const _component = (
    <div className="userMenuBoard hideScrollbar">
      <Column type="item" subType="canonId" data-test="userMenuCanonId">
        {mailAddress}
      </Column>
      <Column type="item" data-test="userEditProfile" onClick={onClickProfile}>
        {glossary.glx(BoardGL.EditProfile)}
      </Column>
      <Column type="item" data-test="userLogout" onClick={onClickLogout}>
        {glossary.glx(BoardGL.Logout)}
      </Column>
    </div>
  );
  return isDisplay ? _component : null;
};
